import ModalInfo from 'components/shared/ModalInfo'
import Text from 'components/shared/Text'
import { FormattedMessage, useIntl } from 'react-intl'
import { useApp } from 'store/steps'
import { useTransport } from 'store/transport-slice/hooks'
import { useCabana } from 'store/cabana-slice/hooks'
import { useUpsell } from 'store/upsell-slice/hooks'
import { PromiseResponse } from 'helpers/types'

interface BackToEditConfirmationModalProps {
    isModalInfoOpen: boolean
    setIsModalInfoOpen: (value: boolean) => void
}

const BackToEditConfirmationModal = ({
    isModalInfoOpen,
    setIsModalInfoOpen,
}: BackToEditConfirmationModalProps) => {
    const { formatMessage } = useIntl()
    const { goBackToStep } = useApp()
    const { removeTransportFromCart } = useTransport(null)
    const { removeCabanasFromCart } = useCabana(null)
    const { removeAllUpsellDataFromCart } = useUpsell({})

    const handleGoBackToStarter = () => {
        const deleteActions: [
            Promise<PromiseResponse>,
            Promise<PromiseResponse>,
            Promise<void>
        ] = [
            removeTransportFromCart(),
            removeCabanasFromCart(),
            removeAllUpsellDataFromCart(),
        ]

        // eslint-disable-next-line compat/compat
        Promise.all(deleteActions).then(() => {
            goBackToStep('starter')
        })
    }

    return (
        <ModalInfo
            isOpened={isModalInfoOpen}
            buttonLabel={formatMessage({
                id: 'global.btn.continue',
                defaultMessage: 'Kontynuuj',
            })}
            linkLabel={formatMessage({
                id: 'global.btn.cancel',
                defaultMessage: 'Anuluj',
            })}
            onButtonClick={handleGoBackToStarter}
            onLinkClick={() => setIsModalInfoOpen(false)}
            testIdPrefix="selfcare-backto-details-modal"
        >
            <Text variant="heading3">
                <FormattedMessage
                    id="selfcare.modal.back_to_details_title"
                    defaultMessage="Czy na pewno chcesz wrócić do szczegółów rezerwacji?"
                />
            </Text>
            <Text variant="body" mt={16}>
                <FormattedMessage
                    id="selfcare.modal.back_to_details_subtitle"
                    defaultMessage="Powrót do szczegółów rezerwacji spowoduje usunięcie wprowadzonych przez Ciebie zmian. Kliknij „Kontynuuj”, aby wrócić do szczegółów rezerwacji."
                />
            </Text>
        </ModalInfo>
    )
}

export default BackToEditConfirmationModal
